// This file is automatically generated. DO NOT EDIT.

import { type RatingResult } from '../../../../types/response/RatingResult';
import { getJSONResponse, type GetJSONResponseOptions } from '@api/internal';

export interface GetRatingResultsResponse {
  /** The results */
  results: Array<RatingResult>;
}

export async function getRatingResultsResponse(
  response: Response,
  options?: GetJSONResponseOptions<GetRatingResultsResponse>,
): Promise<GetRatingResultsResponse> {
  return getJSONResponse<GetRatingResultsResponse>(
    response,
    'getRatingResultsResponse',
    options,
  );
}
